import React from "react";
import { FiPlus } from "react-icons/fi";
import ApiConfig from "../../../config/ApiConfig";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

function AddGroupLayout({
  selectedGroup,
  posts,
  getGroupPosts,
  groupLists,
  listTabs,
}) {
  const navigate = useNavigate();
  // const {active} = listTabs
  // console.log(selectedGroup, groupLists);
  const handleClick = (item) => {
    navigate("/groupactivities", {
      state: { selectedGroup: item, isFromCreate: false },
    });
  };

  const latestList = () => {
    const sortedDates = groupLists?.sort((dateA, dateB) => dateB.updatedAt -dateA.updatedAt)
    console.log(sortedDates)
  }
  latestList()

  return (
    <>
      {selectedGroup && groupLists ? (
        <>
          <div
            // key={i}
            className="d-flex flex-column justify-content-center align-items-start border-bottom mb-3 p-2 cursor-pointer"
            style={{
              height: "auto",
              width: "100%",
              backgroundColor: "rgba(227, 236, 237, 1)",
            }}
          >
            <div
              className="d-flex justify-content-between align-items-start"
              style={{
                height: "auto",
                width: "100%",
                //   backgroundColor: "rgba(227, 236, 237, 1)",
              }}
            >
              <div className="d-flex w-75 align-items-start ">
                <img
                  src={selectedGroup?.groupImage && selectedGroup?.groupImage}
                  onError={(e) => {
                    e.target.src = "images/defaultPlaceholder.jpg"; //replacement image imported above
                  }}
                  alt=""
                  className="object-fit-cover me-3"
                  style={{ borderRadius: "50%", height: "50px", width: "50px" }}
                />

                <div className="flex flex-column justify-content-center align-items-center ">
                  <span
                    style={{
                      fontSize: "0.85rem",
                      fontWeight: "bold",
                      maxHeight: "18px",
                      maxWidth: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {/* {selectedGroup?.groupName.length > 10 ? selectedGroup.groupName.slice(0,10) : selectedGroup.groupName} */}
                    {selectedGroup?.groupName}
                  </span>
                  <p
                    style={{
                      fontSize: "0.7rem",
                      maxHeight: "35px",
                      maxWidth: "150px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    className="mb-1"
                  >
                    {selectedGroup?.description}
                  </p>
                </div>
              </div>
              <div>
                <span
                  className="pe-2"
                  style={{
                    fontSize: "0.7rem",
                    color: "rgba(144, 143, 143, 1)",
                  }}
                >
                  {selectedGroup?.updatedAt ? format(new Date(selectedGroup?.updatedAt), "HH:MM") : "not Updated"}
                </span>
              </div>
            </div>
          </div>
          {groupLists?.map((item) => {
            return (
              <div
                // key={i}
                className="d-flex flex-column justify-content-center align-items-start border-bottom p-2 cursor-pointer"
                onClick={() => handleClick(item)}
                style={{
                  height: "auto",
                  width: "100%",
                  //   backgroundColor: "rgba(227, 236, 237, 1)",
                }}
              >
                <div
                  className="d-flex justify-content-between align-items-start"
                  style={{
                    height: "auto",
                    width: "100%",
                    //   backgroundColor: "rgba(227, 236, 237, 1)",
                  }}
                >
                  <div className="d-flex w-75 align-items-start ">
                    <img
                      src={
                        ApiConfig.ImageUrl +
                        "groups/" +
                        item.createdBy +
                        "/" +
                        item.groupImage
                      }
                      onError={(e) => {
                        e.target.src = "images/defaultPlaceholder.jpg"; //replacement image imported above
                      }}
                      alt=""
                      className="object-fit-cover me-3"
                      style={{
                        borderRadius: "50%",
                        height: "50px",
                        width: "50px",
                      }}
                    />

                    <div className="flex flex-column justify-content-center align-items-center">
                      <p
                        style={{
                          fontSize: "0.85rem",
                          fontWeight: "bold",
                          maxHeight: "18px",
                          maxWidth: "100px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        className="mb-1"
                      >
                        {/* {selectedGroup?.groupName.length > 10 ? selectedGroup.groupName.slice(0,10) : selectedGroup.groupName} */}
                        {item?.groupName}
                      </p>
                      <p
                        style={{
                          fontSize: "0.7rem",
                          maxHeight: "35px",
                          maxWidth: "120px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item?.description}
                      </p>
                    </div>
                  </div>
                  <div>
                    <span
                      className="pe-2"
                      style={{
                        fontSize: "0.7rem",
                        color: "rgba(144, 143, 143, 1)",
                      }}
                    >
                      {item?.updatedAt ?  format(new Date(item?.updatedAt), "HH:MM") : 'not Updtaed'}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <div
          className="d-flex flex-column  justify-content-center align-items-center rounded px-2 py-5"
          style={{
            height: "500px",
            width: "100%",
            backgroundColor: "rgba(227, 236, 237, 1)",
          }}
        >
          <div className="d-flex flex-column text-center justify-content-center align-items-center px-2 py-3 ">
            <span
              className=" text-white bold p-3 mb-5"
              style={{
                borderRadius: "50%",
                backgroundColor: "rgba(31, 126, 120, 1)",
              }}
            >
              <FiPlus
                fontSize={"2rem"}
                className="pointer"
                fontWeight={"bold"}
                onClick={() => navigate("/groupadd")}
              />
            </span>
            <p className="resFont">
              Add New Groups by clicking the "Add New Group" button or{" "}
              <a href="/" style={{ color: "rgba(21, 101, 99, 1)" }}>
                click here
              </a>
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default AddGroupLayout;
